export const UNSET_PASSENGER_SSR_TO_DELETE = 'UNSET_PASSENGER_SSR_TO_DELETE'

export default (passengerId: string, passengerSSRId: string) => ({
  type: UNSET_PASSENGER_SSR_TO_DELETE,
  passengerId,
  passengerSSRId,
})
